import { render, staticRenderFns } from "./DevelopmentProposalsQuestion.vue?vue&type=template&id=a3cbfd3c&scoped=true"
import script from "./DevelopmentProposalsQuestion.vue?vue&type=script&lang=js"
export * from "./DevelopmentProposalsQuestion.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentProposalsQuestion.vue?vue&type=style&index=0&id=a3cbfd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cbfd3c",
  null
  
)

export default component.exports